<script lang="ts" setup>
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Title } from '@/components/ui/title'
import { formatCnpj } from '@/helpers/document'

import { FormSchema } from '@/pages/carts/show.vue'

import { useI18n } from 'vue-i18n'
import BrazillianAddress from './BrazillianAddress.vue'

const { isLoading, form } = defineProps<{
    form: FormSchema
    isLoading: boolean
}>()

const { locale } = useI18n()

const emit = defineEmits(['searchAddressByZipCode'])
</script>

<template>
    <section class="mt-8 space-y-8">
        <fieldset>
            <Title as="legend" size="sm">{{ $t('Company data') }}</Title>
            <p class="mb-8">{{ $t('Enter your company data') }}</p>
            <div class="grid gap-x-2 gap-y-6 md:grid-cols-2 lg:gap-x-8">
                <div class="flex flex-col gap-2">
                    <Label required for="email">{{ $t('Email to send the invoice') }} </Label>
                    <Input id="email" type="text" placeholder="email@email.com" v-model="form.email" />
                    <p v-if="form.errors.email" class="text-destructive mt-px text-xs">{{ $t(form.errors.email) }}</p>
                </div>

                <div class="flex flex-col gap-2">
                    <Label required for="phone">{{ $t('Cellphone') }} </Label>
                    <Input
                        v-if="locale === 'pt-BR'"
                        id="phone"
                        type="tel"
                        :placeholder="$t('(00) 00000-0000')"
                        v-model="form.phone_number"
                        maxlength="15"
                    />
                    <Input id="phone" type="tel" :placeholder="$t('(00) 00000-0000')" v-model="form.phone_number" v-else />
                    <p v-if="form.errors.phone_number" class="text-destructive mt-px text-xs">{{ $t(form.errors.phone_number) }}</p>
                </div>

                <div class="flex flex-col gap-2">
                    <Label for="phone">{{ $t('Phone') }} </Label>

                    <Input id="phone" type="tel" :placeholder="$t('(00) 0000-0000')" v-model="form.another_phone_number" />
                    <p v-if="form.errors.another_phone_number" class="text-destructive mt-px text-xs">{{ $t(form.errors.another_phone_number) }}</p>
                </div>

                <div class="flex flex-col gap-2">
                    <Label required for="company_document">{{ $t('CNPJ') }} </Label>
                    <Input
                        id="company_document"
                        type="text"
                        :placeholder="$t('00.000.000/0001-00')"
                        v-model="form.ein"
                        v-if="locale === 'pt-BR'"
                        @input="(e: Event) => (form.ein = formatCnpj((e.target as HTMLInputElement).value))"
                    />
                    <Input id="company_document" type="text" placeholder="00.000.000/0000-00" v-model="form.ein" v-else />
                    <p v-if="form.errors.ein" class="text-destructive mt-px text-xs">{{ $t(form.errors.ein) }}</p>
                </div>

                <div class="flex flex-col gap-2">
                    <Label required for="legal_name">{{ $t('Corporate reason') }} </Label>
                    <Input id="legal_name" type="text" :placeholder="$t('Enter the company name')" v-model="form.legal_name" />
                    <p v-if="form.errors.legal_name" class="text-destructive mt-px text-xs">{{ $t(form.errors.legal_name) }}</p>
                </div>
            </div>
        </fieldset>

        <fieldset>
            <Title as="legend" size="sm" class="mb-8">{{ $t('Address') }}</Title>

            <BrazillianAddress :form="form" :isLoading="isLoading" @searchAddressByZipCode="emit('searchAddressByZipCode')" />
        </fieldset>
    </section>
</template>
